import { useEffect, useState } from 'react';

/**
 * Desktop vs mobile SSOT — pointer + viewport (not UA).
 * Target: mouse-capable large screens = desktop; touch-first phones = mobile.
 */
export function isDesktop() {
  if (typeof window === 'undefined') return false;
  const fine = window.matchMedia('(pointer: fine)').matches;
  const coarse = window.matchMedia('(pointer: coarse)').matches;
  const wide = window.matchMedia('(min-width: 768px)').matches;
  const touchStart = 'ontouchstart' in window;

  if (fine && !coarse) return true;
  if (fine && wide) return true;
  if (!coarse && wide && !touchStart) return true;
  return false;
}

/** Reactive desktop flag for layout / region picker branching. */
export function useIsDesktop() {
  const [desktop, setDesktop] = useState(() => isDesktop());

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const update = () => setDesktop(isDesktop());
    const queries = ['(pointer: fine)', '(pointer: coarse)', '(min-width: 768px)'].map((q) =>
      window.matchMedia(q),
    );
    queries.forEach((mq) => mq.addEventListener('change', update));
    window.addEventListener('resize', update);
    update();
    return () => {
      queries.forEach((mq) => mq.removeEventListener('change', update));
      window.removeEventListener('resize', update);
    };
  }, []);

  return desktop;
}
